import CommonTable from "./table.jsx";
import {
    createRowCellContentInner,
    getCellClassNameInner,
    TableRowCellText
} from "./table-components.jsx";

export { createRowCellContentInner, getCellClassNameInner, TableRowCellText };
export default CommonTable;